import { Fragment } from "react";
// Só **negrito** e *itálico*, como nós React (nunca HTML). Marcador sem par (stream pela metade) some.
const ENFASE = /\*\*(?=\S)([\s\S]+?)(?<=\S)\*\*|\*(?=[^\s*])([\s\S]+?)(?<=[^\s*])\*/g;
function ler(texto, chave) {
  const nos = [];
  let ultimo = 0;
  for (const m of texto.matchAll(ENFASE)) {
    if (m.index > ultimo) nos.push(texto.slice(ultimo, m.index).replace(/\*/g, ""));
    const k = `${chave}-${m.index}`;
    nos.push(m[1] != null ? <strong key={k}>{ler(m[1], k)}</strong> : <em key={k}>{ler(m[2] ?? "", k)}</em>);
    ultimo = m.index + m[0].length;
  }
  if (ultimo < texto.length) nos.push(texto.slice(ultimo).replace(/\*/g, ""));
  return nos;
}
export default function TextoSuporte({ texto }) {
  return <Fragment>{ler(texto, "e")}</Fragment>;
}
